<div>
  <compare-actions-toolbar
    [reportData]="reportData()"
    [currentView]="currentView()"
    [templates]="templateFieldsCatalog"
    [recordList]="recordList()"
    [isUKFeaturesEnabled]="isUKFeaturesEnabled()"
    (templateChange)="onTemplateSelected($event)"
    >
  </compare-actions-toolbar>
</div>
<div class="container">
  <compare-record-header
    [allFields]="allDataFields"
    [showGroup]="showGroup()"
    [confidentialityTmpl]="confidentialityTmpl()"
  ></compare-record-header>

  <div class="record-body" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onReorder($event)">
    @for (record of reportData()?.records; track record; let order = $index; let isLast = $last) {
      <compare-record-body
        class="body"
        cdkDrag
        cdkDragLockAxis="x"
        [ngClass]="{ last: isLast }"
        [allFields]="allFields"
        [allDataFields]="allDataFields"
        [record]="record"
        [reportLocale]="reportLocale()"
        [reportData]="reportData()"
        [currentView]="currentView()"
        [groupsToDisplay]="bodyGroups"
        [order]="order"
        [recordList]="recordList()"
        [showGroup]="showGroup()"
        [propertyGroups]="propertyGroups"
        (reportUpdateClick)="reportUpdateClick.emit($event)"
        (removeRecord)="removeRecord.emit($event)"
        [confidentialityTmpl]="confidentialityTmpl()"
        >
      </compare-record-body>
    }
  </div>
</div>
